import { createSlice } from "@reduxjs/toolkit";
import { ExpenseResponseDto } from "../../shared/dtos/expense/ExpenseResponseDto";
import { ExpenseSummaryDto } from "../../shared/dtos/expense/ExpenseSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const expenseSlice = createSlice({
  name: "expense",
  initialState: getInitialCrudState<ExpenseResponseDto, ExpenseSummaryDto>(),
  reducers: {
    ...generateCrudReducers<ExpenseResponseDto, ExpenseSummaryDto>(),
  },
});

export const expenseActions = expenseSlice.actions;
export default expenseSlice.reducer;
